import { Organization } from "./../types/auth";
export function getCurrentContract(organization: Organization) {
  return organization.contracts.find(
    (c) => {
      if (!c.accepted) return false;

      const nowDate = new Date();
      const nowTime = nowDate.getTime();

      if (!c.activationDate || new Date(c.activationDate).getTime() > nowTime) return false;
      if (c.cancellationDate && new Date(c.cancellationDate).getTime() <= nowTime) return false;
      if (c.solutionVersion === null) return false;

      return true;
    },
  );
}
export function getLicenseData(organization: Organization) {
  const currentContract = getCurrentContract(organization);
  const currentLicenses = organization.currentLicenses.amount;
  const usedLicenses = organization.activeUsers;
  const remainingLicenses = currentLicenses - usedLicenses;
  const licensePrice = currentContract?.pricePerLicense ?? 100;
  return { currentLicenses, usedLicenses, remainingLicenses, licensePrice };
}

export function billingFrequencyToDanish(billingFrequency: number) {
  switch (billingFrequency) {
    case 1:
      return "/ måned";
    case 3:
      return "/ kvartal";
    case 6:
      return "/ halvår";
    case 12:
      return "/ år";
    default:
      return `/ ${billingFrequency}. måned`;
  }
}
